import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';

const EstructuraAPI2 = () => {
  const [fechaSeleccionada, setFechaSeleccionada] = useState('');
  const [fechaSeleccionada2, setFechaSeleccionada2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [respuesta, setRespuesta] = useState(null);
  const [jsonRecibido, setJsonRecibido] = useState(null);
  const [seleccionados, setSeleccionados] = useState({});
  const [filtros, setFiltros] = useState({
    usuario: '',
    comentario: '',
    estado: '',
    compañia: '',
    area: '',
  });

  const handleFiltroChange = (e) => {
    setFiltros({
      ...filtros,
      [e.target.name]: e.target.value,
    });
  };

  // Función de filtrado mejorada
// Función de filtrado mejorada con manejo seguro de tipos
const registrosFiltrados = respuesta 
  ? respuesta.filter((solicitud) => {
      // Convertir a string y manejar valores nulos/undefined
      const usuario = String(solicitud.cmj_codusu || '');
      const comentario = String(solicitud.cmj_comentario || '');
      const estado = String(solicitud.cmj_estado || '');
      const compañia = String(solicitud.cia_descripcion || '');
      const area = String(solicitud.arf_nombre || '');

      // Verificar cada filtro solo si tiene valor
      const cumpleUsuario = filtros.usuario 
        ? usuario.toLowerCase().includes(filtros.usuario.toLowerCase())
        : true;
      
      const cumpleComentario = filtros.comentario 
        ? comentario.toLowerCase().includes(filtros.comentario.toLowerCase())
        : true;
      
      const cumpleEstado = filtros.estado 
        ? estado.toLowerCase().includes(filtros.estado.toLowerCase())
        : true;
      
      const cumpleCompañia = filtros.compañia 
        ? compañia.toLowerCase().includes(filtros.compañia.toLowerCase())
        : true;
      
      const cumpleArea = filtros.area 
        ? area.toLowerCase().includes(filtros.area.toLowerCase())
        : true;

      return cumpleUsuario && cumpleComentario && cumpleEstado && cumpleCompañia && cumpleArea;
    })
  : [];

  const handleCheckboxChange = (cmj_codigo) => {
    setSeleccionados((prev) => ({
      ...prev,
      [cmj_codigo]: !prev[cmj_codigo],
    }));
  };

  const seleccionarTodos = (e) => {
    const isChecked = e.target.checked;
    const nuevosSeleccionados = {};
    
    if (isChecked && registrosFiltrados) {
      registrosFiltrados.forEach((solicitud) => {
        nuevosSeleccionados[solicitud.cmj_codigo] = true;
      });
    }
    setSeleccionados(nuevosSeleccionados);
  };

  const enviarSeleccionados = async () => {
    if (!registrosFiltrados) return;

    const datosSeleccionados = registrosFiltrados.filter(
      (solicitud) => seleccionados[solicitud.cmj_codigo]
    );

    if (datosSeleccionados.length === 0) {
      setError('Por favor, selecciona al menos un elemento.');
      return;
    }

    const datosEnviar = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      User: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      Metodo: {
        NombreMetodo: 'ComentarioMarcasAplicado',
        Datos_Recibidos: JSON.stringify(
          datosSeleccionados.map((solicitud) => ({
            CodEmp: solicitud.cmj_codusu,
            Fecha: solicitud.cmj_fecha.split('-').reverse().join('/'),
            CodEmpAut: solicitud.cmj_codusu_aut,
          }))
        ),
        datos_Generados: '',
      },
    };

    try {
      setLoading(true);
      const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosEnviar),
      });

      const data = await response.json();
      if (data.mensaje) {
        alert(`Respuesta del servidor: ${data.mensaje}`);
      } else {
        alert('Respuesta recibida sin mensaje.');
      }
    } catch (error) {
      console.error('Error al enviar los datos:', error);
      setError('Error al enviar los datos seleccionados.');
    } finally {
      setLoading(false);
    }
  };

  const exportarAExcel = () => {
    if (!registrosFiltrados || registrosFiltrados.length === 0) {
      setError('No hay datos para exportar.');
      return;
    }

    const ws = XLSX.utils.json_to_sheet(registrosFiltrados);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Solicitudes');
    XLSX.writeFile(wb, 'solicitudes.xlsx');
  };

  const enviarDatos = async () => {
    setLoading(true);
    setError(null);
    setRespuesta(null);
    setJsonRecibido(null);
    setSeleccionados({});

    if (!fechaSeleccionada || !fechaSeleccionada2) {
      setError('Por favor, selecciona ambas fechas.');
      setLoading(false);
      return;
    }

    const fechaFormateada = fechaSeleccionada.replace(/-/g, '');
    const fechaFormateada2 = fechaSeleccionada2.replace(/-/g, '');

    const datos = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      Usr: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      DatosMetodo: {
        NombreMetodo: 'ObtenerListaComentarioMarcas',
        Datos_Recibidos: JSON.stringify({ FechaIni: fechaFormateada, FechaFin: fechaFormateada2 }),
      },
    };

    try {
      const response = await fetch(`https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
        JSON.stringify(datos)
      )}`);
      const data = await response.json();
      setJsonRecibido(data);

      if (data.datos_Generados) {
        const datosGenerados = JSON.parse(data.datos_Generados);
        
        if (typeof datosGenerados.SOLICITUDES === 'string') {
          datosGenerados.SOLICITUDES = JSON.parse(datosGenerados.SOLICITUDES);
        }
        console.log(datosGenerados.SOLICITUDES)
        setRespuesta(datosGenerados.SOLICITUDES);
      } else {
        setError('No se encontraron datos generados en la respuesta.');
      }
    } catch (error) {
      console.error('Error al procesar la respuesta:', error);
      setError('Error al procesar la respuesta de la API.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h1>Solicitudes de Cambios Marcajes</h1>
      <div className="d-flex align-items-end gap-3 mb-3">
        <div className="flex-grow-1">
          <label className="form-label">Fecha Inicial:</label>
          <input
            type="date"
            className="form-control"
            value={fechaSeleccionada}
            onChange={(e) => setFechaSeleccionada(e.target.value)}
          />
        </div>
        <div className="flex-grow-1">
          <label className="form-label">Fecha Final:</label>
          <input
            type="date"
            className="form-control"
            value={fechaSeleccionada2}
            onChange={(e) => setFechaSeleccionada2(e.target.value)}
          />
        </div>
        <div>
          <button
            className="btn btn-primary"
            onClick={enviarDatos}
            disabled={loading}
          >
            {loading ? 'Cargando...' : 'Enviar Datos'}
          </button>
        </div>
      </div>

      {/* Sección de Filtros */}
      <div className="row mb-3 mt-3">
        <div className="col-md-2">
          <input 
            type="text" 
            name="usuario" 
            className="form-control" 
            placeholder="Codigo Empleado" 
            value={filtros.usuario} 
            onChange={handleFiltroChange} 
          />
        </div>
        <div className="col-md-2">
          <input 
            type="text" 
            name="comentario" 
            className="form-control" 
            placeholder="Comentario" 
            value={filtros.comentario} 
            onChange={handleFiltroChange} 
          />
        </div>
        <div className="col-md-2">
          <input 
            type="text" 
            name="estado" 
            className="form-control" 
            placeholder="Estado" 
            value={filtros.estado} 
            onChange={handleFiltroChange} 
          />
        </div>
        <div className="col-md-2">
          <input 
            type="text" 
            name="compañia" 
            className="form-control" 
            placeholder="Compañía" 
            value={filtros.compañia} 
            onChange={handleFiltroChange} 
          />
        </div>
        <div className="col-md-2">
          <input 
            type="text" 
            name="area" 
            className="form-control" 
            placeholder="Área" 
            value={filtros.area} 
            onChange={handleFiltroChange} 
          />
        </div>
      </div>

      {error && <div className="alert alert-danger mt-3">{error}</div>}

      {respuesta && (
        <div className="mt-4">
          <h2>Respuesta:</h2>
          <div className="d-flex mb-3">
            <button
              className="btn btn-success me-2"
              onClick={enviarSeleccionados}
              disabled={loading}
            >
              {loading ? 'Enviando...' : 'Enviar Seleccionados'}
            </button>
            {/* <button
              className="btn btn-primary"
              onClick={exportarAExcel}
              disabled={registrosFiltrados.length === 0}
            >
              Exportar a Excel
            </button> */}
          </div>
          
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      onChange={seleccionarTodos}
                      checked={Object.keys(seleccionados).length > 0 && 
                        Object.keys(seleccionados).length === registrosFiltrados.length}
                    />
                  </th>
                  <th>Código</th>
                  <th>Usuario</th>
                  <th>Fecha</th>
                  <th>Comentario</th>
                  <th> Solicitante</th>
                  <th>Estado</th>
                  <th>Fecha Procesamiento</th>
                  <th>Nombre Completo</th>
                  <th>Puesto</th>
                  <th>Unidad</th>
                  
                 
                </tr>
              </thead>
              <tbody>
                {registrosFiltrados.map((solicitud, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        checked={!!seleccionados[solicitud.cmj_codigo]}
                        onChange={() => handleCheckboxChange(solicitud.cmj_codigo)}
                      />
                    </td>
                    <td>{solicitud.cmj_codigo}</td>
                    <td>{solicitud.cmj_codusu}</td>
                    <td>{solicitud.cmj_fecha}</td>
                    <td>{solicitud.cmj_comentario}</td>
                    <td>{solicitud.Usuario_Solicita}</td>
                    <td>{solicitud.cmj_estado}</td>
                    <td>{solicitud.cmj_fecha_proc}</td>
                    <td>{solicitud.exp_apellidos_nombres}</td>
                    <td>{solicitud.plz_nombre}</td>
                    <td>{solicitud.uni_descripcion}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default EstructuraAPI2;